import { TeamShiftAssignmentActionTypes } from "./constans";

export const teamShiftAssignmentApiResponseSuccess = ( actionType = '', data = {} ) => ({
  type: TeamShiftAssignmentActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const teamShiftAssignmentApiResponseError = ( actionType = '', error = '' ) => ({
  type: TeamShiftAssignmentActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const exportTeamShiftAssignment = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.EXPORT_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};

export const importTeamShiftAssignment = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.IMPORT_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};

export const getTeamShiftAssignmentList = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};

export const getTeamShiftAssignmentListById = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.GET_TEAM_SHIFT_ASSIGNMENT_BY_ID,
    payload: { params },
  }
};

export const addTeamShiftAssignment = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.ADD_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};

export const updateTeamShiftAssignment = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.UPDATE_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};

export const deleteTeamShiftAssignment = (params) => {
  return {
    type: TeamShiftAssignmentActionTypes.DELETE_TEAM_SHIFT_ASSIGNMENT,
    payload: { params },
  }
};